import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './components/Landing';
import Privacy from './components/Privacy';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;